<script>
  import { page } from '@inertiajs/svelte';
  import viewport from '@/js/utils/useViewportAction.js';

  export let title = '';
  export let items = [];
  export let link = {};
  let grow = false;
</script>

<section
  class="more-wrap"
  class:grow
  use:viewport
  on:enterViewport={() => (grow = true)}
>
  <div class="container container--medium">
    {#if title}
      <h2 class="more-title tagline text-center">{@html title}</h2>
    {/if}

    <div class="more-list">
      {#each items as item}
        <article class="more-item text-center">
          <img
            class="more-item__icon"
            src={`${$page.props.asset_url}img/color-chevron-up.svg`}
            width="13"
            height="7"
            alt="arrow down"
          />
          <h3 class="h6">{item.title}</h3>
          <p class="more-item__text text-micro">{item.info}</p>
          <div class="line-vertical" />
        </article>
      {/each}
    </div>

    {#if Object.values(link).length}
      <div class="text-center more-link">
        <a class="btn btn-icon btn-main btn-main--dark" href={link.url}>
          {link.text}
          <i class="isax isax-arrow-right-1" />
        </a>
      </div>
    {/if}
  </div>
</section>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .more-wrap {
    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }

    @include resp-max('s') {
      padding-top: 0;
    }
  }
  .more-title {
    margin: 0 0 3rem;
  }

  .more-list {
    display: flex;
    flex-wrap: wrap;

    @include resp-max('s') {
      row-gap: 3rem;
    }
  }

  .more-item {
    @include resp-min('m') {
      width: 25%;
    }

    @include resp-max('m') {
      padding: 3rem 3rem;
    }

    @include resp-max('s') {
      padding: 0.5rem;
    }

    width: 50%;
    position: relative;
    padding: 3rem 6rem;

    &__icon {
      margin: 0 auto 1rem;
      transform: rotate(180deg);
    }

    &__text {
      color: var(--royal-light);
    }

    .line-vertical {
      @include resp-max('m') {
        display: none;
      }

      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
    }

    &:last-child {
      .line-vertical {
        display: none;
      }
    }
  }

  .more-link {
    margin: 3rem 0 0;
  }
</style>
